/**
 * https://mariadb.com/kb/en/data-types/
 */
export const MariaDBTypes: string[] = [
  'BIGINT',
  'BINARY',
  'BIT',
  'BLOB',
  'BOOL',
  'BOOLEAN',
  'CHAR',
  'DATE',
  'DATETIME',
  'DEC',
  'DECIMAL',
  'DOUBLE PRECISION',
  'DOUBLE',
  'ENUM',
  'FIXED',
  'FLOAT',
  'GEOMETRY',
  'GEOMETRYCOLLECTION',
  'INT',
  'INTEGER',
  'JSON',
  'LINESTRING',
  'LONGBLOB',
  'LONGTEXT',
  'MEDIUMBLOB',
  'MEDIUMINT',
  'MEDIUMTEXT',
  'MULTILINESTRING',
  'MULTIPOINT',
  'MULTIPOLYGON',
  'NUMERIC',
  'POINT',
  'POLYGON',
  'REAL',
  'SET',
  'SMALLINT',
  'TEXT',
  'TIME',
  'TIMESTAMP',
  'TINYBLOB',
  'TINYINT',
  'TINYTEXT',
  'VARBINARY',
  'VARCHAR',
  'YEAR',
];
